import React, { useEffect, useState } from 'react';
import { ClientApiProps, ICallsignApplicationEx, ICallsignTransferExt, parseQuery } from '../../common';
import {
  Acma_amateurradiocallsign_statuscode,
  getApiClient,
  msalGetToken,
  ICallsignApplicationResult,
  IOperatorCallsign,
  IChargingRule,
  ICallsignTransfer,
  CallsignTransfer,
} from '../../api';
import { AlertProvider, FileDownloadFormats, Form, ModalProps, downloadBlob } from 'acma-spa';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CallsignTransferApplicationPage } from './Page';
import { ModalForm } from '../../common/ModalForm';

export interface CallsignTransferApplicationFormParams {
  [keys: string]: string | undefined;
  id?: string;
}

export interface CallsignTransferApplicationFormProps extends ClientApiProps {
  callsignTarget: IOperatorCallsign | undefined;
  closeDlg: () => any;
  onSubmit: (callsign: IOperatorCallsign | undefined) => any;
}

export const CallsignTransferApplicationForm: React.FC<CallsignTransferApplicationFormProps> = (props) => {
  const params = useParams<CallsignTransferApplicationFormParams>();
  const location = useLocation();

  const [fee, setFee] = useState<number>();
  const [readOnly, setReadOnly] = useState(false);

  const refresh = (src: ICallsignApplicationEx) => {
    setReadOnly(src.status != Acma_amateurradiocallsign_statuscode.Draft); // todo
  };

  const load: { (): Promise<[ICallsignTransferExt, number]> } = async () => {
    const [client] = getApiClient(props.baseUrl, props.b2cDomainName, props.msalClient);
    const res = params.id ? await client.callsignApplicationGetById(params.id) : null;

    const operator = await client.operatorGet(undefined);
    const fee = await client.callsignTransferGET();
    setFee(fee);

    if (res != null) {
      refresh(res);
      return [{ ...res }, 0];
    } else {
      let init: ICallsignTransferExt;

      let idTokenClaims: Record<string, any> | undefined = {};
      const accountInfo = props.msalClient.getAllAccounts();

      if (accountInfo.length > 0) {
        idTokenClaims = accountInfo[0].idTokenClaims;
      }

      init = {};

      return [init, 0];
    }
  };

  const save = async (m: ICallsignTransferExt, submit?: boolean): Promise<ICallsignTransferExt> => {
    var application = new CallsignTransfer({
      ...m,
      callSignId: props.callsignTarget?.callsignId,
      callSignName: props.callsignTarget?.name
    });

    const [client] = getApiClient(props.baseUrl, props.b2cDomainName, props.msalClient);
    var data = submit ? await client.callsignTransferPOST(application) : await client.callsignTransferPUT(application);
    window.scroll(0, 0);

    if (data.error) {
      window.scroll(0, 0);
      throw new Error(data.error);
    }

    submit && props.onSubmit(props.callsignTarget);

    return data.application ?? m;
  };

  return (
    <>
      <ModalForm<ICallsignTransferExt>
        id="transferDlg"
        title="Call sign transfer application"
        closeDlg={props.closeDlg}
        open={!!props.callsignTarget}
        onConfirm={(m) => save(m, true)}
        onLoad={load}
        onPrint={(model, fmt: FileDownloadFormats) => {
          const fileExt = fmt === FileDownloadFormats.Pdf ? 'pdf' : 'docx';
          const url = `${props.baseUrl}/api/CallsignApplications/print/${fmt}`;
          const defaultFilename = `${model.referenceNumber ?? 'registration'}.${fileExt}`;
          const mimeType = fmt === FileDownloadFormats.Pdf ? `application/pdf` : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          const mscalScopes = [`https://${props.b2cDomainName}.onmicrosoft.com/AcmaApis/Call`];
          return downloadBlob(url, props.msalClient, mscalScopes, defaultFilename, mimeType, model);
        }}
        readOnly={readOnly}
        //onSave={save}
        onSubmit={(m) => save(m, true)}
        onExit={(m, submit) => {
          props.closeDlg();
          return undefined;
        }}>
        {(ctx) => {
          switch (ctx?.page) {
            case 0:
              return <CallsignTransferApplicationPage {...props} ctx={ctx} fee={fee} callsignname={props.callsignTarget?.name} />;
            default:
              return <></>;
          }
        }}
      </ModalForm>
    </>
  );
};
